import React from "react";
import Button from "../base/button";
import Icon from "../icons/icon";

const NavigationCard = (navigationCard) => {
  const { icon, title, copy, link } = navigationCard;

  return (
    <li className="navigation-card">
      <Button type="navigation-card__link" href={link} wrapper={false}>
        <Icon name={icon} />
        <h4>{title}</h4>
        <p>
          {copy}
          <i>
            <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.58574 10L1.29285 2.70711L2.70706 1.29289L11.4142 10L2.70706 18.7071L1.29285 17.2929L8.58574 10Z"
                fill="#52288E"
                stroke="#52288E"
              />
            </svg>
          </i>
        </p>
      </Button>
    </li>
  );
};

export default NavigationCard;
